import type { MasterContactDetail } from "../../../api/client.ts";
import { getCountryFlag } from "../../../components/CountryName.tsx";
import ContactAboutCard from "./ContactAboutCard.tsx";
import ContactBackgroundCard from "./ContactBackgroundCard.tsx";
import ContactTimelineCard from "./ContactTimelineCard.tsx";
import ReachabilityCard from "./ReachabilityCard.tsx";

/** "Oslo, 🇳🇴 NO": where the person lives, for a header line. */
export function contactLocation(contact: MasterContactDetail): string {
  return [contact.city, contact.country ? `${getCountryFlag(contact.country)} ${contact.country}` : null]
    .filter(Boolean)
    .join(", ");
}

/**
 * Everything about a person under their header: about, reachability, work
 * history and background. The contact page and the contact drawer show the same.
 */
export default function ContactProfileSections({
  contact,
  showPhoto,
}: {
  contact: MasterContactDetail;
  /** Off where the header already shows the photo. */
  showPhoto?: boolean;
}) {
  return (
    <>
      {contact.profile && <ContactAboutCard name={contact.full_name} profile={contact.profile} showPhoto={showPhoto} />}
      <ReachabilityCard reachability={contact.reachability} contactId={contact.id} />
      <ContactTimelineCard employment={contact.employment} />
      {contact.profile && <ContactBackgroundCard profile={contact.profile} />}
    </>
  );
}
